import { Controller } from '@hotwired/stimulus';

// Counts down to the Resend link. With an autoSend form on the page the first code is requested
// here, as a POST the page submits on arrival; a Turbo cache preview is not an arrival.
export default class extends Controller {
  static targets = ['countdown', 'link', 'autoSend']
  static values = { seconds: { type: Number, default: 30 } }

  connect() {
    this.start();
    if (this.hasAutoSendTarget && !document.documentElement.hasAttribute('data-turbo-preview')) {
      this.autoSendTarget.requestSubmit();
    }
  }

  disconnect() {
    clearInterval(this.timer);
  }

  start() {
    clearInterval(this.timer);
    this.remaining = this.secondsValue;
    this.render();
    this.timer = setInterval(() => {
      this.remaining -= 1;
      this.render();
      if (this.remaining <= 0) clearInterval(this.timer);
    }, 1000);
  }

  render() {
    const waiting = this.remaining > 0;
    this.countdownTarget.hidden = !waiting;
    this.linkTarget.hidden = waiting;
    if (!waiting) return;

    const minutes = Math.floor(this.remaining / 60);
    const seconds = String(this.remaining % 60).padStart(2, '0');
    this.countdownTarget.textContent = `Resend code in ${minutes}:${seconds}`;
  }
}
